import React, { Component } from "react";
import { BusinessForm, AboutUsForm, AppView } from "components";
import { FormContainer, FlexColumn, BlueBackGround } from "appStyles";
import { withRedux, relocateImage } from "helpers";
import { privateFetch, postMockAppData } from "apis";
import AwesomeDebouncePromise from "awesome-debounce-promise";

// ping /checkUniqueAppCode
const checkUniqueAppCode = (appCode) => {
  if (appCode) {
    return new Promise((resolve, reject) => {
      return privateFetch(
        `${__BASE_API_URL__}/checkUniqueAppCode?code=${appCode}`
      )
        .then(resolve)
        .catch(reject);
    });
  }
};

const debouncedCheckUniqueAppCode = AwesomeDebouncePromise(
  checkUniqueAppCode,
  800
);
class NewAppBusiness extends Component {
  componentDidMount() {
    // set appView to about us on app creation
    const aboutUsTemplateId = this.props.activeApp.view.templates[0].id;
    this.props.actions.setTemplate(null, aboutUsTemplateId);

    const userId = this.props.platformInfo.status.user.id;
    this.props.actions.setBusinessUserId(userId);
  }

  // BusinessForm Props
  addLocation = () => {
    this.props.actions.addBusinessLocation();
  };

  addPhoneNumber = (locationIdx) => {
    this.props.actions.addBusinessPhoneNumber(locationIdx);
  };

  removeLocation = (locationIdx) => {
    this.props.actions.removeBusinessLocation(locationIdx);
  };

  removePhoneNumber = (locationIdx, phoneIdx) => {
    this.props.actions.removeBusinessPhoneNumber(locationIdx, phoneIdx);
  };

  updateBusiness = (field) => (value) => {
    this.props.actions.updateBusiness(field, value);
  };

  updateLocation = (locationIdx, key) => (value) => {
    this.props.actions.updateBusinessLocation(locationIdx, key, value);
  };

  updatePhoneNumber = (locationIdx, phoneIdx, key) => (value) => {
    this.props.actions.updateBusinessPhoneNumber(
      locationIdx,
      phoneIdx,
      key,
      value
    );
  };

  getStorePage = () => {
    return this.props.activeApp.view.templates.filter(
      (t) => t.type === "store"
    );
  };

  createBusinessApp = async () => {
    const { business, activeApp } = this.props;
    // add prefilled templates
    // this.props.actions.addNewTemplate("store", { nav: true });
    this.props.actions.addNewTemplate(
      "titleTextCustom",
      { nav: true },
      activeApp
    );
    this.props.actions.addNewTemplate(
      "imageTitleTextCustom",
      { nav: true },
      activeApp
    );
    this.props.actions.addNewTemplate(
      "instructional",
      { nav: true },
      activeApp
    );
    this.props.actions.addNewTemplate("punchCard", { nav: true });
    this.props.actions.addNewTemplate("store", { nav: true });

    activeApp.view.navigation.components.forEach((t) => {
      switch (t.title.text) {
        case "Ordering Instructions":
          t.order = 2;
          break;
        case "Store":
          t.order = 3;
          break;
        case "About Me":
          t.order = 4;
          break;
        case "Templates Explained":
          t.order = 5;
          break;
        case "Punch Card":
          t.order = 6;
          break;
        default:
      }
    });
    // console.dir(activeApp.view.navigation.components);
    // console.log("title text barebones template...");
    let storeTemplateId = this.getStorePage()[0].id;

    // return;
    this.props.actions
      .postBusinessApp(business, activeApp)
      .then((updatedApp) => {
        const result = postMockAppData(updatedApp.id, storeTemplateId);

        updatedApp.view.templates.forEach((t) => {
          this.props.actions.unpublishTemplate(t.id);
        });

        const { id, mainImageLink } = updatedApp;

        if (mainImageLink) {
          relocateImage(mainImageLink, { id }).then((cloudinaryLink) => {
            this.props.actions
              .putAppAndDispatch({
                ...updatedApp,
                mainImageLink: cloudinaryLink,
              })
              .then((cb) => {
                this.props.history.push({
                  pathname: "/application",
                });
              });
          });
        } else {
          this.props.history.push({
            pathname: "/application",
          });
        }
      })
      .catch((e) => console.log("Failed to redirect after save:", e));
  };

  // aboutUsProps
  updateImage = (url) => {
    this.props.actions.updateApplicationImage(url);
  };

  updateLogoImage = (url) => {
    this.props.actions.updateApplicationLogo(url);
  };

  addLink = () => {
    this.props.actions.addApplicationLink();
  };

  removeLink = (linkIdx) => {
    this.props.actions.removeApplicationLink(linkIdx);
  };

  clearLink = (linkIdx) => {
    this.props.actions.updateApplicationLink("url", linkIdx, "");
  };

  updateLinkIcon = (image, linkIdx) => {
    this.props.actions.updateApplicationLink("icon", linkIdx, image.url);
  };

  updateLink = (field, linkIdx) => (e) => {
    let value = e.currentTarget.value;
    this.props.actions.updateApplicationLink(field, linkIdx, value);
  };

  updateApp = (field) => (value) => {
    if (field === "code") {
      debouncedCheckUniqueAppCode(value).then((appCodeAvailable) => {
        this.props.actions.updateApplicationInfo(
          "appCodeAvailable",
          appCodeAvailable
        );
      });
    }

    this.props.actions.updateApplicationInfo(field, value);
  };

  render() {
    const aboutUsProps = {
      updateImage: this.updateImage,
      addLink: this.addLink,
      removeLink: this.removeLink,
      clearLink: this.clearLink,
      updateLinkIcon: this.updateLinkIcon,
      updateLogoImage: this.updateLogoImage,
      updateLink: this.updateLink,
      updateApp: this.updateApp,
    };
    const width = "auto";
    return (
      <div>
        <div
          style={{
            width: "625px",
            overflowY: "scroll",
            height: "90vh",
            paddingRight: "2em",
            backgroundColor: "white",
            paddingLeft: "2em",
            position: "relative",
            zIndex: "20",
            borderRight: "1px solid rgb(100 121 143 / 12%)",
          }}
        >
          <div style={{ margin: "30px 0px", textAlign: "center" }}>
            <h1 className="heading">Tell Us About What You’re Building!</h1>
            <p>
              The information you provide here will help build your
              application’s contact page.
            </p>
          </div>

          <AboutUsForm
            newBusiness={true}
            application={this.props.activeApp}
            {...aboutUsProps}
          />
          <BusinessForm
            newBusiness={true}
            business={this.props.business}
            addLocation={this.addLocation}
            addPhoneNumber={this.addPhoneNumber}
            removeLocation={this.removeLocation}
            removePhoneNumber={this.removePhoneNumber}
            updateBusiness={this.updateBusiness}
            updateLocation={this.updateLocation}
            updatePhoneNumber={this.updatePhoneNumber}
            createBusinessApp={this.createBusinessApp}
            application={this.props.activeApp}
            width={width}
          />
        </div>
        <AppView scale="0.8" top="2em" />
      </div>
    );
  }
}

export default withRedux(NewAppBusiness);
